import { StartingPoint } from './types/tracking';

type OtherPlaces = {
  id: number;
  to: string;
  name: string;
  address: { street?: string; city?: string };
  rating: number;
};

export type ProfilePageState = {
  popularPlaces: OtherPlaces[];
  similarPlaces: OtherPlaces[];
  lastVisitedPlaces: OtherPlaces[];
  showPopup: boolean;
  showVerifyModal: { show: boolean; trigger?: StartingPoint };
};

type ProfilePageAction =
  | { type: 'SET_POPULAR_PLACES'; payload: OtherPlaces[] }
  | { type: 'SET_SIMILAR_PLACES'; payload: OtherPlaces[] }
  | { type: 'SET_LAST_VISITED_PLACES'; payload: OtherPlaces[] }
  | { type: 'SET_SHOW_POPUP'; payload: boolean }
  | { type: 'SET_SHOW_VERIFY_MODAL'; payload: { show: boolean; trigger?: StartingPoint } };

export const profilePageReducer = (state: ProfilePageState, action: ProfilePageAction): ProfilePageState => {
  switch (action.type) {
    case 'SET_POPULAR_PLACES':
      return { ...state, popularPlaces: action.payload };
    case 'SET_SIMILAR_PLACES':
      return { ...state, similarPlaces: action.payload };
    case 'SET_LAST_VISITED_PLACES':
      return { ...state, lastVisitedPlaces: action.payload };
    case 'SET_SHOW_POPUP':
      return { ...state, showPopup: action.payload };
    case 'SET_SHOW_VERIFY_MODAL':
      return { ...state, showVerifyModal: action.payload, showPopup: false };
    default:
      return state;
  }
};
